import { IModel, IAttribute } from '../base/annotation';
import { Metamodel } from 'app/model/base/model';

import { format } from 'app/shared/utils/string.util';
import { Dataset } from './dataset';

@Metamodel.model({
    name: 'AdobeExperiencePlatformObject',
    display: [
        format(stringResources.ModelName_DatasetTemplate, stringResources.AdobeExperiencePlatform_DisplayText),
        format(stringResources.ModelName_DatasetsTemplate, stringResources.AdobeExperiencePlatform_DisplayText)
    ]
})
export class AdobeExperiencePlatformObjectDataset extends Dataset {
    public static readonly MODEL: IModel;
    public static readonly DATASET_ID: IAttribute;

    @Metamodel.attribute({
        templatable: true,
        association: 'DATASET_ID',
        constraint: {
            required: true
        },
        display: stringResources.ModelName_DatasetId
    })
    public datasetId: string;

    public constructor(name?: string, description?: string) {
        super(name, description);
        this.isV2 = true;
    }
}
